import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import deviceSelect from '@blade/common/components/device-cascader-select/index.vue';
import moment from 'moment';
import { getSnapImageListByImage, detectTypes } from '@blade-sxp/monitor-center/api/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import snapDetails from '@blade-sxp/monitor-center/pages/components/snap-details/details.vue';
import { formatSnapImageList } from '@blade-sxp/monitor-center/utils';
import ImageUtil from '@blade/common/utils/image-util';
import sliderInput from '@blade/common/components/slider-input/index.vue';
import datePicker from '@blade/common/components/date-time-select/index.vue';
import DetailsPage from '@blade/common/pages/result-details/index.vue';
import { trackSpace, allTrack, deleteTrack } from '@blade-sxp/search-center/api/index';
import colors from '@/styles/color.scss';
// 抓拍列表的默认参数
const formData = {
    size: 20,
    groupTime: 10,
    similarity: 95,
};
let SnapRecord = class SnapRecord extends Vue {
    moment = moment;
    activeBorderColor = colors.borderItemHover;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    loading = false;
    $refs;
    viewList = [];
    sourceImage = '';
    // showBtn = true;
    showPath = true;
    detailLoading = false;
    routeData = [];
    maxNums = 0;
    defaultTime = ['00:00:00', '23:59:59'];
    // url传递的参数
    getImage;
    // 表单数据
    form = {
        snapDates: [moment().add(-7, 'd').format('yyyy-MM-DD HH:mm:ss'), moment().format('yyyy-MM-DD HH:mm:ss')],
        deviceIdList: [],
        similarity: formData.similarity,
        page: 1,
        size: formData.size,
        groupTime: formData.groupTime,
    };
    pagination = {
        pages: [10, 20, 50, 100],
        total: 0,
    };
    minNum = 0;
    maxNum = 100;
    groupTimeOptions = [
        {
            value: 10,
            label: '10 Min',
        },
        {
            value: 30,
            label: '30 Min',
        },
        {
            value: 60,
            label: '60 Min',
        },
        {
            value: 1440,
            label: '24 Hour',
        },
    ];
    // 抓拍列表
    snapImageList = [];
    // 接口返回的list
    rawSnapImageList = [];
    // 弹窗
    dialogVisible = false;
    details = {};
    activeIndex = {
        imgIdx: 0,
        groupIdx: 0,
    };
    get routeType() {
        return this.$route.query.type || 'features';
    }
    get setPrivacyMode() {
        return this.privacyMode === 'true' ? 6 : 0;
    }
    get pickerOptions() {
        return {
            shortcuts: [
                {
                    text: this.$t('week'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    },
                },
                {
                    text: this.$t('halfMonth'),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                        picker.$emit('pick', [start, end]);
                    },
                },
            ],
            disabledDate: (date) => moment(date).subtract(1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD')),
        };
    }
    getSimilarity(similarity) {
        return `${(similarity * 100).toFixed(2)}% `;
    }
    handleSizeChange(val) {
        this.form.size = val;
        this.form.page = 1;
        this.getSnapImage();
    }
    handleCurrentChange(val) {
        this.form.page = val;
        this.getSnapImage();
    }
    next() {
        this.handleImageChange(1);
    }
    prev() {
        this.handleImageChange(-1);
    }
    showBtn(btnPath) {
        this.showPath = btnPath;
    }
    addRoute(img) {
        const params = {
            ...img,
            // trackType: this.trackType(),
            trackType: 'OBJECT_FACE',
        };
        this.detailLoading = true;
        trackSpace(params)
            .then((res) => {
            img.checked = true;
            this.showPath = false;
            this.getAllcount();
        })
            .finally(() => {
            this.detailLoading = false;
        });
    }
    deletedRoute(img) {
        const route = this.routeData.find((e) => e.captureUrl === img.captureUrl);
        if (!route)
            return;
        this.deleteRoute(route.id, route);
    }
    deleteRoute(imageId, route) {
        this.detailLoading = true;
        deleteTrack(imageId)
            .then((res) => {
            this.getAllcount();
            // this.showList.list.find((e: any) => e.captureUrl === route.captureUrl)!.checked = false;
            this.showPath = true;
        })
            .finally(() => {
            this.detailLoading = false;
        });
    }
    getAllcount() {
        allTrack().then((res) => {
            if (res) {
                this.routeData = res;
                this.maxNums = res.length;
                // this.checkIsChecked();
            }
        });
    }
    closeDetails() {
        this.dialogVisible = false;
    }
    handleReset() {
        this.form = {
            snapDates: [],
            deviceIdList: [],
            similarity: formData.similarity,
            page: 1,
            size: formData.size,
            groupTime: formData.groupTime,
        };
        this.initParams();
        this.getSnapImage();
    }
    getSnapImage() {
        this.loading = true;
        this.snapImageList = [];
        this.getImage
            .then(({ base64Image: imageUrl, featureList }) => {
            const { snapDates, groupTime, similarity, ...other } = this.form;
            const [startTime = moment().add(-7, 'd').format('yyyy-MM-DD HH:mm:ss'), endTime = moment().format('yyyy-MM-DD HH:mm:ss')] = snapDates || [];
            return getSnapImageListByImage({
                ...other,
                dateStart: startTime,
                dateEnd: endTime,
                imageSearchRequest: {
                    threshold: similarity / 100,
                    imageUrl: imageUrl,
                    featureList: featureList,
                },
            }).then((res) => {
                let list = [];
                let total = 0;
                res.searchList.forEach((item) => {
                    if (item.list) {
                        list = list.concat(item.list);
                        total += item.total;
                    }
                });
                this.rawSnapImageList = list;
                this.snapImageList = formatSnapImageList(list, groupTime);
                this.pagination.total = total;
            });
        })
            .catch(() => {
            this.snapImageList = [];
            this.pagination.total = 0;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    groupTimeChange() {
        this.loading = true;
        this.snapImageList = formatSnapImageList(this.rawSnapImageList, this.form.groupTime);
        this.loading = false;
    }
    handleImageChange(changeVal) {
        let { imgIdx, groupIdx } = this.activeIndex;
        if (changeVal > 0) {
            // 向后翻页
            if (imgIdx === this.viewList.length - 1) {
                // 是该组最后一个
                if (groupIdx === this.snapImageList.length - 1) {
                    // 是当页最后一组
                    return; // 翻不动了直接return
                }
                groupIdx++;
                this.viewList = this.snapImageList[groupIdx].list; // 否则取下一个组
                imgIdx = 0;
            }
            else {
                imgIdx++;
            }
        }
        else {
            // 向前翻页
            if (!imgIdx) {
                // 是该时间组第一个
                if (!groupIdx) {
                    // 是第一个时间组
                    return; // 翻不动了直接return
                }
                groupIdx--;
                this.viewList = this.snapImageList[groupIdx].list; // 否则取上一个组
                imgIdx = this.viewList.length - 1;
            }
            else {
                imgIdx--;
            }
        }
        this.activeIndex = { imgIdx, groupIdx };
        this.details = this.viewList[imgIdx];
    }
    // 抓拍详情
    viewDetails(val, imgIdx, groupIdx, list) {
        this.details = {
            ...val,
        };
        this.viewList = list;
        this.activeIndex = { imgIdx, groupIdx };
        this.dialogVisible = true;
    }
    closeDialog() {
        this.dialogVisible = false;
    }
    confirmDialog() {
        this.dialogVisible = false;
    }
    // 获取链接上的参数
    initParams() {
        const { params } = this.$route.query;
        const { startTime, endTime, image } = JSON.parse(params);
        this.sourceImage = image;
        // if (deviceId) {
        //   this.form.deviceIdList = deviceId;
        // }
        if (startTime && endTime) {
            this.form.snapDates = [startTime, endTime];
        }
        if (!this.getImage) {
            // 获取图片中的特征
            const canvas = document.createElement('canvas');
            this.getImage = ImageUtil.drawImage(image, canvas).then(() => {
                const base64Image = canvas.toDataURL();
                return detectTypes({ base64Image }).then((data) => {
                    let featureList = [];
                    data.forEach((item) => {
                        if (item.featureList) {
                            featureList = featureList.concat(item.featureList.map((feature) => {
                                return {
                                    ...feature,
                                    imageUrl: '',
                                };
                            }));
                        }
                    });
                    if (!featureList || !featureList.length) {
                        this.$message.error(`${this.$t('errMsg')}`);
                        // throw '没有识别到人脸人体';
                    }
                    else {
                        return {
                            featureList,
                            base64Image,
                        };
                    }
                });
            });
        }
    }
    mounted() {
        this.initParams();
        this.getSnapImage();
    }
};
SnapRecord = __decorate([
    Component({
        components: { deviceSelect, BlurPicture, sliderInput, snapDetails, datePicker, DetailsPage },
        i18n: {
            messages: {
                en: {
                    device: 'Device',
                    similarity: 'Similarity',
                    pictures: 'pictures',
                    total: 'Total {num} Items',
                    noData: 'No Data',
                    startPlaceholder: 'Start',
                    endPlaceholder: 'End',
                    errMsg: 'No Human Face Is Detected',
                },
                zh: {
                    week: '近一周',
                    halfMonth: '近15天',
                    device: '设备',
                    similarity: '相似度',
                    pictures: '图片',
                    total: '总共 {num} 条',
                    noData: '暂无数据',
                    startPlaceholder: '开始时间',
                    endPlaceholder: '结束时间',
                    errMsg: '未检测到人脸人体',
                },
            },
        },
    })
], SnapRecord);
export default SnapRecord;
